export default [{
  name: 'caption',
  value: 1,
  unit: 'px'
}];